var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.75C13 15.4833 12.3917 16.9583 11.175 18.175C9.95833 19.3917 8.48333 20 6.75 20C5.01667 20 3.54167 19.3917 2.325 18.175C1.10833 16.9583 0.5 15.4833 0.5 13.75V4.5C0.5 3.25 0.9375 2.1875 1.8125 1.3125C2.6875 0.4375 3.75 0 5 0C6.25 0 7.3125 0.4375 8.1875 1.3125C9.0625 2.1875 9.5 3.25 9.5 4.5V13.25C9.5 14.0167 9.23333 14.6667 8.7 15.2C8.16667 15.7333 7.51667 16 6.75 16C5.98333 16 5.33333 15.7333 4.8 15.2C4.26667 14.6667 4 14.0167 4 13.25V4H6V13.25C6 13.4667 6.07083 13.6458 6.2125 13.7875C6.35417 13.9292 6.53333 14 6.75 14C6.96667 14 7.14583 13.9292 7.2875 13.7875C7.42917 13.6458 7.5 13.4667 7.5 13.25V4.5C7.48333 3.8 7.2375 3.20833 6.7625 2.725C6.2875 2.24167 5.7 2 5 2C4.3 2 3.70833 2.24167 3.225 2.725C2.74167 3.20833 2.5 3.8 2.5 4.5V13.75C2.48333 14.9333 2.89167 15.9375 3.725 16.7625C4.55833 17.5875 5.56667 18 6.75 18C7.91667 18 8.90833 17.5875 9.725 16.7625C10.5417 15.9375 10.9667 14.9333 11 13.75V4H13V13.75Z",
    fill: "#3D4910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.c9fbf0c8c24e1de0348142522e0d0f53.svg";
export { ForwardRef as ReactComponent };